import React, { useState, useEffect } from 'react';
import './WebPrompt.css';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

const WebPrompt: React.FC = () => {
  const [companyName, setCompanyName] = useState('');
  const [businessModel, setBusinessModel] = useState('');
  const [logo, setLogo] = useState<string | null>(null);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const [isGenerating, setIsGenerating] = useState(false);
  const [isProcessStarted, setIsProcessStarted] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      history.push('/PantallaInicial');
    }
  }, [history]);

  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };


  const handleCreate = async () => {
    
    if (companyName) {
      localStorage.setItem('companyName', companyName);
    }

    setIsLoading(true); // Iniciar la barra de carga
    setIsGenerating(true);
    setIsProcessStarted(true); // Marcar que el proceso ha comenzado

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No hay token de autenticación disponible');
      }

      // Restamos los créditos (10 créditos en este caso)
      console.log("Iniciando proceso para restar créditos...");

      const creditosResponse = await axios.post(`${backendUrl}/restar-creditos`, {
        cantidad: 10
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      console.log('Respuesta de restar créditos:', creditosResponse.data); // Verificar respuesta

      if (creditosResponse.data.success) {

        if (companyName && businessModel && logo) {
          try {
            const repoResponse = await axios.post(`${backendUrl}/api/crear-repo`, {
              companyName, // Enviar el nombre de la empresa
            }, {
              headers: { 'Authorization': `Bearer ${token}` }
            });
    
            const repoUrl = repoResponse.data.repoUrl;
            console.log('Repositorio creado:', repoUrl);
    
            // Almacenar la URL del repositorio en localStorage para reutilizarla más tarde
            localStorage.setItem('repoUrl', repoUrl);
    
            const responseTitle = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'mainTitle',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseParagraph = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'mainParagraph',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseSubparagraph = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'mainSubparagraph',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseTestimonials = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'testimonials',
              businessModel,
              companyName, // Añadir companyName
            });

            // New sections for business model
            const responseTitulo1 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'titulo-1',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseSubtitulo1 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'subtitulo-1',
              businessModel,
              companyName, // Añadir companyName
            });
            // New sections for business model
            const responseTitulo2 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'titulo-2',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseSubtitulo2 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'subtitulo-2',
              businessModel,
              companyName, // Añadir companyName
            });
            // New sections for business model
            const responseTitulo3 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'titulo-3',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseSubtitulo3 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'subtitulo-3',
              businessModel,
              companyName, // Añadir companyName
            });
            // New sections for business model
            const responseTitulo4 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'titulo-4',
              businessModel,
              companyName, // Añadir companyName
            });
            const responseSubtitulo4 = await axios.post(`${backendUrl}/generate-landing-content`, {
              section: 'subtitulo-4',
              businessModel,
              companyName, // Añadir companyName
            });

            const generatedContent = {
              mainTitle: responseTitle.data.content,
              mainParagraph: responseParagraph.data.content,
              mainSubparagraph: responseSubparagraph.data.content,
              testimonials: responseTestimonials.data.content.split('\n'),
              titulo1: responseTitulo1.data.content,
              subtitulo1: responseSubtitulo1.data.content,
              titulo2: responseTitulo2.data.content,
              subtitulo2: responseSubtitulo2.data.content,
              titulo3: responseTitulo3.data.content,
              subtitulo3: responseSubtitulo3.data.content,
              titulo4: responseTitulo4.data.content,
              subtitulo4: responseSubtitulo4.data.content,
            };

            const landingData = {
              companyName,
              businessModel,
              logo,
              ...generatedContent,
            };

            localStorage.setItem('landingData', JSON.stringify(landingData));
            history.push('/LandingResult');
            
          } catch (error: unknown) {
            console.error('Error al generar el contenido:', error);
            if (error instanceof Error) {
              console.error(`Error al subir el archivo ${__filename}:`, error.message);
            } else if (typeof error === 'object' && error !== null && 'response' in error) {
              console.error(`Error al subir el archivo ${__filename}:`, (error as any).response?.data);
            }
            alert('Hubo un error al generar el contenido. Por favor, inténtalo de nuevo.');
          }
          finally {
            setIsLoading(false); // Detener la barra de carga al finalizar
          }
        } else {
          alert("Por favor, complete todos los campos y suba un logo.");
        }
        localStorage.setItem('companyName', companyName);

        console.log('Créditos restados correctamente. Procediendo con el siguiente paso...');
        // Aquí puedes manejar lo que ocurra después, como navegar a otra página
      } else {
        console.error('Problema al restar créditos:', creditosResponse.data.mensaje);
        alert(creditosResponse.data.mensaje);
      }
    } catch (error) {
      console.error("Error al restar créditos:", error);
      alert('Ha ocurrido un error al restar créditos.');
    } finally {
      setIsGenerating(false);
    }
  };



  return (
    <div className="landing-form-container">
      <Helmet>
        <title>Crea tu Landing - Tu Negocio</title>
      </Helmet>
      <h2 className="landing-form-title">Crea tu <span className="highlight">Landing</span></h2>
      <h3 className="landing-form-subtitle">Para tu Negocio</h3>
      <hr className="landing-form-divider" />
      <label className="landing-form-label">Escribe el nombre de tu empresa <span className="highlight">aquí</span>.</label>
      <input
        type="text"
        className="landing-form-input"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
        placeholder="Tienda de Ropa XYZ"
      />
      <label className="landing-form-label">Describe tu modelo de negocio <span className="highlight">aquí</span>.</label>
      <textarea
        className="landing-form-textarea"
        value={businessModel}
        onChange={(e) => setBusinessModel(e.target.value)}
        placeholder="Vendemos ropa sostenible y de comercio justo, enfocado a jóvenes."
      />
      <label className="landing-form-label">Sube el logo de tu empresa <span className="highlight">aquí</span>.</label>
      <input
        type="file"
        className="landing-form-input"
        accept="image/*"
        onChange={handleLogoChange}
      />
      {logo && (
        <div className="landing-form-logo-preview">
          <img src={logo} alt="Logo Preview" className="logo-preview" />
        </div>
      )}

      {isLoading ? (
        <div>
          <div className="loading-bar"></div>
          <p className="loading-text">Cargando...</p> {/* Añade esta clase */}
        </div>) : (
        <button
          className="landing-form-button"
          onClick={handleCreate}
          disabled={isLoading} // Deshabilitar botón si está cargando
        >
          Crear
        </button>
      )}
    </div>
  );
};

export default WebPrompt;
